import Icon from '../components/Icon.vue'

Icon.register({
  'drumstick-bite': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M462.8 49.6c34.3 34.3 50.4 79.6 49.1 124.6-42-22.7-94.4-17.6-128.7 16.8-40.9 40.8-40.7 107.2-1.1 151.1-16.2 5.5-43.3 10-60.5 10-0.4 0-1 0-1.4 0h-85.9l-40.6 40.6c-9.7 9.8-11.1 24-6 36.8 2.4 6 4.3 16 4.3 22.4 0 33.3-27 60.3-60.4 60.3-13.8 0-33-8-42.8-17.8-15.3-15.3-19.6-36.5-15.1-56.1-19.6 4.5-40.8 0.2-56.1-15.1-9.8-9.8-17.7-28.9-17.7-42.7 0-33.3 27-60.3 60.3-60.3 6.4 0 16.4 1.9 22.4 4.3 12.8 5.1 27.1 3.7 36.8-6l40.6-40.6v-85.8c0-64 27.7-107 63.2-142.4 27.4-27.4 81-49.6 119.8-49.6 38.7 0 92.4 22.2 119.8 49.6z'
      }
    ]
  }
})
